import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://jydbudoqtbuzjjfvslef.supabase.co';
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imp5ZGJ1ZG9xdGJ1empqZnZzbGVmIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDQzMTA2MzEsImV4cCI6MjA1OTg4NjYzMX0.xbo64T2kdeJGQB33Wt9ByysgOUCUXjvQ9rtgbTUfx0o';
export const supabase = createClient(supabaseUrl, supabaseKey);